import styled from '@emotion/styled';
import { AdvancedImage } from '@cloudinary/react';
import { breakpoints, spacing } from '@naf/theme';

export const StyledStep = styled.div`
  display: flex;

  @media (max-width: ${breakpoints.m}) {
    flex-direction: column;
    min-width: calc(100% - 48px);
    scroll-snap-align: center;
  }
`;

export const IconWrapper = styled.div`
  margin-right: ${spacing.space32};
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: ${breakpoints.m}) {
    margin: 0;
    min-width: 40px;
  }
`;

export const TextContent = styled.div`
  padding-right: ${spacing.space32};
`;

export const StyledAdvancedImage = styled(AdvancedImage)`
  max-width: 100%;
  min-width: 100px;

  @media (max-width: ${breakpoints.m}) {
    max-width: 50%;
  }
`;
